export class ContactDetails {

  constructor(
    public firstName: string,
    public lastName: string,
    public email: string,
    public contactPhone: string) {
  }

  getFullName(): string {
    return this.sanitise(`${this.sanitise(this.firstName)} ${this.sanitise(this.lastName)}`);
  }

  hasContactDetails(): boolean {
    return this.isNotEmpty(this.getFullName()) && this.isNotEmpty(this.email) && this.isNotEmpty(this.contactPhone);
  }

  private sanitise(s: string): string {
    return (s ?? '').trim();
  }

  private isNotEmpty(s: string): boolean {
    return !!this.sanitise(s);
  }
}
